const words = [
  "Brand Strategy",
  "GTM Execution",
  "Programmatic Ads",
  "AI × Marketing",
  "Sales Force Effectiveness",
  "Category Storytelling",
  "Data-Driven Growth",
  "Portfolio Launches",
  "Field Enablement",
  "Consumer Insight",
];

export default function Marquee() {
  const row = [...words, ...words];
  return (
    <div className="py-8 md:py-12 border-y border-[color:var(--border)] bg-[color:var(--linen-2)]">
      <div className="marquee">
        <div className="marquee-track font-display text-3xl md:text-5xl font-light">
          {row.map((w, i) => (
            <span key={i} className="flex items-center gap-12">
              <span>{w}</span>
              <span className="text-[color:var(--accent)]">✦</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
